








































































import axios from 'axios'
import * as dayjs from 'dayjs'
import { Component, Prop } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Recruit from '@/models/Recruit'

@Component
export default class RecruitCard extends VueBase {
  @Prop(Object) readonly value!: Recruit

  categories: { [key: string]: string; } = {
    'pm': 'PM',
    'se': 'SE',
    'pg': 'PG',
    'we': 'WE',
    'ne': 'Ne',
    'other': '他'
  }

  get thumbnailImage(): any {
    return this.value.company_image1 ? this.value.company_image1.thumbnail_url : require('@/img/noimage.jpg')
  }

  get updatedAtString(): string {
    return this.value ? dayjs(this.value.updated_at).format('YYYY/MM/DD') : ''
  }

  categoryStyle(key: string): string {
    const styles = [key]
    if (this.value.viewable_jobs.some(j => j.tag.format_tag_key === key)) {
      styles.push('selected')
    }
    return styles.join(' ')
  }
}
